import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import style from './style.module.css';

const Burger = React.forwardRef(
  ({ className, open, onClick, ...rest }, ref) => {
    const customClassName = classNames(style.burger, 'burger', className, {
      [style['-open']]: open,
      [style['-close']]: !open,
    });

    return (
      <button
        {...rest}
        type="button"
        ref={ref}
        className={customClassName}
        onClick={onClick}
      >
        <span className={style.box}>
          <span className={style.inner} />
        </span>
      </button>
    );
  }
);

Burger.propTypes = {
  className: PropTypes.string,
  open: PropTypes.bool,
  onClick: PropTypes.func,
};

Burger.defaultProps = {
  className: null,
  onClick: () => {},
  open: false,
};

export default Burger;
